var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "z-video",
      style: { width: _vm.width },
      on: { mouseover: _vm.handleMouseOver, mouseout: _vm.handleMouseOut },
    },
    [
      _c(
        "div",
        {
          staticClass: "z-video__title",
          class: {
            "z-video__title--visible":
              _vm.title && _vm.started && (_vm.paused || _vm.hovered),
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
      ),
      _vm._v(" "),
      _c("video", {
        ref: "videoPlayer",
        staticClass: "video-js vjs-default-skin",
        attrs: { controls: "", preload: "auto" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }